module.exports = __webpack_public_path__ + "static/img/office-img-1-292x300.61aad1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-1-292x300.jpg
// module id = qH/s
// module chunks = 0